import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=34e99723&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=34e99723&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e99723",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e99723')) {
      api.createRecord('34e99723', component.options)
    } else {
      api.reload('34e99723', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=34e99723&scoped=true", function () {
      api.rerender('34e99723', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/siteinfo/jcGuide/detail.vue"
export default component.exports